import Component from '@cell/cell-core/component/section';
import './stepper.scss';

class Stepper extends Component {
  constructor() {
    super();

    this.step = 1;
    this.totalSteps = this.parsedDataset.totalSteps;

    this.firstLeft = 0;
  }

  componentDidMount() {
    this.determineProgressPositionAndWidth();

    globalThis.on('resize', this.handleResize.bind(this));
  }

  determineProgressPositionAndWidth() {
    const distanceToLeftEdge = this.getBoundingClientRect().left;

    const firstDotElement = this.querySelectorAll('.StepperItem__Dot')[0];
    const lastDotElement = [...this.querySelectorAll('.StepperItem__Dot')].at(-1);

    this.firstLeft = firstDotElement.getBoundingClientRect().left;
    const { left: lastLeft } = lastDotElement.getBoundingClientRect();

    this.querySelector('.Stepper__ProgressLineWrapper').style.left = `${
      this.firstLeft - distanceToLeftEdge
    }px`;

    this.querySelector('.Stepper__ProgressLineWrapper').style.width = `${
      lastLeft - this.firstLeft
    }px`;
  }

  handleResize() {
    // This will recalculate the progress width accordingly.
    this.determineProgressPositionAndWidth();
  }

  next() {
    if (this.step === this.totalSteps + 1) {
      // TODO: Should we throw an error instead?

      return;
    }

    this.step++;

    this.update();
  }

  prev() {
    if (this.step === 1) {
      // TODO: Should we throw an error instead?

      return;
    }

    this.step--;

    this.update();
  }

  goTo(step) {
    if (step > this.totalSteps + 1) {
      // TODO: Should we throw an error instead?

      return;
    }

    if (step < 1) {
      // TODO: Should we throw an error instead?

      return;
    }

    this.step = step;

    this.update();
  }

  update() {
    const currentStepIndex = this.step - 1;

    // Either the dot element that matches the current step index or the last dot element
    // as a fallback (in case of the final step).
    const activeDotElement =
      this.querySelectorAll('.StepperItem__Dot')[currentStepIndex] ??
      [...this.querySelectorAll('.StepperItem__Dot')].at(-1);

    const distanceToActiveDot = Math.max(
      activeDotElement.getBoundingClientRect().left -
        this.getBoundingClientRect().left -
        // this.firstLeft,
        0,
    );
    this.querySelector('.Stepper__ProgressLine').style.width = `${distanceToActiveDot}px`;

    this.querySelectorAll('.StepperItem__Dot').forEach((stepperItemDotElement, index) => {
      if (index === currentStepIndex) {
        stepperItemDotElement.classList.add('StepperItem__Dot--Active');
        stepperItemDotElement.classList.remove('StepperItem__Dot--Completed');
      } else if (index < currentStepIndex) {
        stepperItemDotElement.classList.remove('StepperItem__Dot--Active');
        stepperItemDotElement.classList.add('StepperItem__Dot--Completed');
      } else {
        stepperItemDotElement.classList.remove('StepperItem__Dot--Active');
        stepperItemDotElement.classList.remove('StepperItem__Dot--Completed');
      }
    });
  }
}

customElements.define('c-stepper', Stepper);
